<template>
  <invoice-manage :direction="2"></invoice-manage>
</template>

<script>
import InvoiceManage from './InvoiceManage';

export default {
  name: 'InputInvoice',
  components: {
    InvoiceManage
  }
}
</script>
